import React, {useState, useEffect } from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
 

const ReceiveBulkStakeEdit = ()=>{
     const [betid, setBetid ] = useState('');
     const [customerId, setCustomerId ] = useState('');
     const [mobileNo, setMobileNo ] = useState('');
     const [punterAmt, setPunterAmt ] = useState('');
     const [desc, setDesc ] = useState('');
     const [stakeAmt, setStakeAmt ] = useState('');
     const [stakeType, setStakeType ] = useState('');
     const [odds, setOdds ] = useState('');
     const [dateOfStake, setDateOfStake ] = useState('');
     const [exciseAmt, setExciseAmt ] = useState('');
     const [walletBalanceStake, setWalletBalanceStake ] = useState('');
    const [redirect, setRedirect] = useState(false);
 

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`receiveBulkStake/${id}`);
                 setBetid(data.betid);
                 setCustomerId(data.customer_id);
                 setMobileNo(data.mobile_no);
                 setPunterAmt(data.punter_amt);
                 setDesc(data.desc);
                 setStakeAmt(data.stake_amt);
                 setStakeType(data.stake_type);
                 setOdds(data.odds);
                 setDateOfStake(data.date_of_stake);
                 setExciseAmt(data.excise_amt);
                 setWalletBalanceStake(data.wallet_balance_stake);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`receiveBulkStake/${id}`, {
            betid,
            customerId,
            mobileNo,
            punterAmt,
            desc,
            stakeAmt,
            stakeType,
            odds,
            dateOfStake,
            exciseAmt,
            walletBalanceStake,
        });
        console.log(data);
        setRedirect(true);
    };
    
    if(redirect){
         return <Navigate to={'/receiveBulkStakes'} />
    }
    return (
        <Wrapper pageTitle={'Edit Stake Data'}>
            <InnerNav createLink={'/receiveBulkStakeCreate'} listLink={'/receiveBulkStakes'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Bet id </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Betid" value={betid}
                        onChange = {e => setBetid(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Customer Id </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="CustomerId" value={customerId}
                        onChange = {e => setCustomerId(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Mobile No </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="MobileNo" value={mobileNo}
                        onChange = {e => setMobileNo(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Punter Amt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="PunterAmt" value={punterAmt}
                        onChange = {e => setPunterAmt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Desc </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Desc" value={desc}
                        onChange = {e => setDesc(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Stake Amt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="StakeAmt" value={stakeAmt}
                        onChange = {e => setStakeAmt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Stake Type </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="StakeType" value={stakeType}
                        onChange = {e => setStakeType(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Odds </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Odds" value={odds}
                        onChange = {e => setOdds(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Date Of Stake </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="DateOfStake" value={dateOfStake}
                        onChange = {e => setDateOfStake(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Excise Amt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ExciseAmt" value={exciseAmt}
                        onChange = {e => setExciseAmt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Wallet Balance Stake </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="WalletBalanceStake" value={walletBalanceStake}
                        onChange = {e => setWalletBalanceStake(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default ReceiveBulkStakeEdit;